import { get } from 'lodash';
import { useCallback, useEffect } from 'react';
import { useStore } from 'react-redux';
import { useDispatch } from 'react-redux';
import ModelConfirm from 'src/components/modals/confirm';
import { notificationChanel, socketEvents } from 'src/config';
import { useActionConfimSubmit } from 'src/hooks/use-action-confirm-submit';
import useNotificationDispatcher from 'src/hooks/use-notification-dispatcher';
import useSocketConnnect from 'src/hooks/use-socket-connect';
import { setClientActiveInteract } from 'src/store/app-slice';

export const PushNotification = ({ uid }) => {
  const socketRef = useSocketConnnect({
    path: notificationChanel.push,
    query: { clientId: uid }
  });

  const dispatchNotification = useNotificationDispatcher();

  useEffect(() => {
    const socket = socketRef.current;

    if (!socket) return;

    // Lắng nghe thông báo từ room response_room
    // const handleRecivePushNotification = ({ type, ...data }) => {
    //   console.log('NotificationCenter Received push notification:', data);
    //   if (type === pushNotificationsType.bookingRequest) {
    //   }

    //   // Xử lý logic khi nhận được dữ liệu từ room
    // };

    // Lắng nghe các sự kiện từ server
    // socket.on('request_room_event', handleRequestRoomEvent);
    socket.on(socketEvents.on.push_notification, dispatchNotification);

    // Cleanup lắng nghe sự kiện khi unmount
    return () => {
      // socket.off('request_room_event', handleRequestRoomEvent);
      socket.off(socketEvents.on.push_notification, dispatchNotification);
    };
  }, [socketRef]);

  return <></>;
};

export const ModelConfirmClientActive = () => {
  const dispatch = useDispatch();
  const store = useStore();
  const handleActionConfirm = useActionConfimSubmit();

  const handleAgreeActiveInteract = useCallback(() => {
    try {
      dispatch(setClientActiveInteract(true));
    } catch (error) {
      console.log('handleAgreeActiveInteract error ', error);

      throw error;
    }
  }, []);

  useEffect(() => {
    const appState = store.getState().app;
    const isActiveInteract = get(appState, 'clientActive.interact', false);
    if (!isActiveInteract) {
      handleActionConfirm.handleOpenDialogConfirm({
        title: `Cài đặt`,
        message: 'Bật âm báo khi có kèo',
        labelButton: 'Bật',

        handleAgree: handleAgreeActiveInteract
      });
    }
  }, []);
  return (
    <ModelConfirm
      params={handleActionConfirm.state.params}
      open={handleActionConfirm.state.open}
      title={handleActionConfirm.state.title}
      message={handleActionConfirm.state.message}
      labelButton={handleActionConfirm.state.labelButton}
      handleClose={handleActionConfirm.handleCloseDialogConfirm}
      handleAgree={handleActionConfirm.handleAgreeDialogConfirm}
    />
  );
};
export default PushNotification;
